import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-white border-y border-line" data-id="element-20" data-mp="22fmv4tjdi00j">
      <div className="max-w-5xl mx-auto" data-id="element-21" data-mp="22ety4ka7uovl">
        <div className="text-center mb-16" data-id="element-22" data-mp="1yeb72sg5dmug">
          <p className="text-gold-dark font-bold tracking-widest uppercase mb-2" data-id="element-23" data-mp="1yejgubgz4c1f">
            Included With Your Purchase at No Additional Cost
          </p>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-ink" data-id="element-24" data-mp="15pw26yqqckwu">
            <span className="text-gold" data-id="element-25" data-mp="1jgr75zy3yhv5">5</span> EXCLUSIVE WORKPLACE SAFETY{' '}
            <span className="text-forest" data-id="element-26" data-mp="1jivekrv7tz06">INSTRUCTOR BONUSES</span>
          </h2>
          <p className="text-lg text-graphite/80 max-w-3xl mx-auto mt-5" data-id="element-27" data-mp="1eor9ke5ig11q">
            The six main volumes give you professional visual resources for workplace safety
            instruction. And the five additional bonuses provide written teaching resources to help you
            plan lessons, organize scenarios, assess knowledge and prepare training sessions more
            efficiently.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-28" data-mp="2eoti60scyiw2">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white border border-line rounded-2xl p-8 shadow-sm shadow-ink/5 relative flex flex-col ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-29" data-mp="2jk8siir5pwnq" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-forest text-gold-light px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-30" data-mp="25oesyqc9wjna">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-gold-soft border border-gold rounded-full flex items-center justify-center text-gold-dark mb-4" data-id="element-31" data-mp="3h3tqpwcb3fjg">
                <Gift size={24} data-id="element-32" data-mp="1c4ki2iuupcjf" />
              </div>
              <h3 className="text-xl font-bold tracking-tight mb-2 pr-28 text-ink" data-id="element-33" data-mp="1c42f73doo02j">{bonus.title}</h3>
              <p className="text-forest text-sm font-semibold mb-4 border-l-4 border-gold pl-4" data-id="element-34" data-mp="1q3agq2xbjk9w">
                {bonus.subtitle}
              </p>
              {bonus.intro && <p className="text-graphite text-sm mb-4 leading-relaxed" data-id="element-35" data-mp="ydp9l7o9kxgd">{bonus.intro}</p>}

              {bonus.bullets && <>
                  <p className="text-ink font-semibold text-sm mb-3" data-id="element-36" data-mp="175r5csne1pkb">{bonus.bulletsIntro}</p>
                  <ul className={`mb-6 ${bonus.bullets.length > 8 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-2' : 'space-y-2'} ${index === 4 ? 'md:grid-cols-4' : ''}`} data-id="element-37" data-mp="12er7nl6g33gr">
                    {bonus.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-38" data-mp="jo7nmjc42z2">
                        <CheckCircle2 size={16} className="text-forest shrink-0 mt-0.5" data-id="element-39" data-mp="hjt8ant7lkj" />
                        <span className="text-graphite text-sm" data-id="element-40" data-mp="5c7n6p1l186i">{bullet}</span>
                      </li>)}
                  </ul>
                </>}

              {bonus.detailedBullets && <>
                  <p className="text-ink font-semibold text-sm mb-3" data-id="element-41" data-mp="j9mha72s644t">{bonus.bulletsIntro}</p>
                  <ul className="mb-6 space-y-3" data-id="element-42" data-mp="o9ihdv8cxbf3">
                    {bonus.detailedBullets.map(item => <li key={item.title} className="flex items-start gap-3" data-id="element-43" data-mp="9aoimbbn4u83">
                        <CheckCircle2 size={16} className="text-forest shrink-0 mt-0.5" data-id="element-44" data-mp="ea9t9j06ar0n" />
                        <div data-id="element-45" data-mp="2u274w5us749u">
                          <span className="block text-ink font-bold text-sm" data-id="element-46" data-mp="2u0vzy2plnqh5">{item.title}</span>
                          <span className="block text-graphite text-sm" data-id="element-47" data-mp="2z238i3zkgtov">{item.detail}</span>
                        </div>
                      </li>)}
                  </ul>
                </>}

              {bonus.secondaryBullets && <>
                  <p className="text-ink font-semibold text-sm mb-3" data-id="element-48" data-mp="35hk7tvjyhzac">
                    {bonus.secondaryBulletsIntro}
                  </p>
                  <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-2" data-id="element-49" data-mp="30l3hqvt75aum">
                    {bonus.secondaryBullets.map(bullet => <li key={bullet} className="text-forest font-semibold text-sm bg-gold-soft border border-gold/40 rounded-lg px-3 py-2" data-id="element-50" data-mp="3t87iupp65514">
                        {bullet}
                      </li>)}
                  </ul>
                  {bonus.secondaryNote && <p className="-mt-3 mb-6 text-graphite text-sm italic" data-id="element-51" data-mp="2crlazdzisxv4">{bonus.secondaryNote}</p>}
                </>}

              <div className="mt-auto space-y-3" data-id="element-52" data-mp="ndc13r585dpu">
                {bonus.system && <div data-id="element-53" data-mp="sb435dzl2g7r">
                    <p className="text-ink font-semibold text-sm mb-2" data-id="element-54" data-mp="scf4z89gxdw8">{bonus.systemLabel}</p>
                    <p className="text-ink font-bold text-xs sm:text-sm tracking-wide bg-gold-soft border-l-4 border-gold rounded-lg px-3 py-2" data-id="element-55" data-mp="x9p1t8z6sru3">
                      {bonus.system}
                    </p>
                  </div>}
                {bonus.result && <div className="bg-forest-50 border border-forest-100 border-l-4 border-l-forest rounded-xl p-4" data-id="element-56" data-mp="1b1df3fl69mcn">
                    <span className="text-forest font-bold block mb-1" data-id="element-57" data-mp="1g29epgyhqmc9">RESULT</span>
                    <p className="text-graphite text-sm" data-id="element-58" data-mp="1l0ksu3vtjj0a">{bonus.result}</p>
                  </div>}
                {bonus.closing && <div className="pt-4 border-t border-line" data-id="element-59" data-mp="3hup7e52higk0">
                    {bonus.closing.map((line, lineIndex) => <p key={line} className={lineIndex === 0 ? 'text-ink font-extrabold text-base tracking-wide' : 'text-ink font-semibold text-sm italic'} data-id="element-60" data-mp="3eqq4gm5piqb4" data-mpi={lineIndex}>
                        {line}
                      </p>)}
                  </div>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}